/*
 * Select multiple items
 *
 * Example:
 *
 * JS:
 * const carousels = datajsAll('carousel-block');
 *
 * carousels.forEach((carousel) => {
 *    this.carouselConfig(carousel);
 * });
 *
 * HTML:
 * <div class="o-carousel__slides" data-js="carousel-block">
 */
export function datajsAll(selector, parent) {
	return Array.prototype.slice.call((parent || document).querySelectorAll('[data-js~="' + selector + '"]'));
}

/*
 * Select first (single) item
 *
 * Example:
 *
 * JS:
 * const headerHeight = datajs('site-header').offsetHeight;
 *
 * HTML:
 * <header class="o-siteHeader" data-js="site-header">
 */
export function datajs(selector, parent) {
	return (parent || document).querySelector('[data-js~="' + selector + '"]');
}

// Trap focus helper
export function trapFocus(element) {
	const focusableEls = element.querySelectorAll(
		'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
	);
	const firstFocusableEl = focusableEls[0];
	const lastFocusableEl = focusableEls[focusableEls.length - 1];
	const KEYCODE_TAB = 9;

	element.addEventListener('keydown', function (e) {
		const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;

		if (!isTabPressed) {
			return;
		}

		if (e.shiftKey) {
			/* shift + tab */ if (document.activeElement === firstFocusableEl) {
				lastFocusableEl.focus();
				e.preventDefault();
			}
		} /* tab */ else {
			if (document.activeElement === lastFocusableEl) {
				firstFocusableEl.focus();
				e.preventDefault();
			}
		}
	});
}

// Set a cookie 'cname' with value 'cvalue' that expires after 'exhour' hours
export function setCookieHour(cname, cvalue, exhour) {
	cvalue = encodeURIComponent(cvalue);
	var d = new Date();
	d.setTime(d.getTime() + 1 * exhour * 60 * 60 * 1000);
	var expires = 'expires=' + d.toUTCString();
	document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/;';
}

// Get a cookie by 'cname'
export function getCookie(cname) {
	var name = cname + '=';
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1);
		if (c.indexOf(name) != -1) return decodeURIComponent(c.substring(name.length, c.length));
	}
	return '';
}
